const ToolLists = [
  {
    name: "pen",
  },
  {
    name: "move",
  },
  {
    name: "eraser",
  },

  {
    name: "line",
  },
  {
    name: "rectangle",
  },
  {
    name: "circle",
  },
  {
    name: "spray",
  },
  {
    name: "fill",
  },
];

export default ToolLists;
